import React from 'react';
import { connect } from 'react-redux';
import { CorperateDetailContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { portalService } from 'apiServices';
import momentTZ from 'moment-timezone';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';
import {
  ACTIVITY_RENDER_TYPE,
  ACTIVITY_RENDER_STATUS,
} from 'utils/functions/activity';
import { RENDER_STATUS_PRODUCT_WARRANTY } from 'utils/functions/productWarranty';
import { RENDER_ORGANIZATION_TIMELINE } from 'utils/functions/corperate';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { Displays, Tables } from 'components';
import { CorperateInfoWidget } from 'widgets';

class CorperateDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      this.fetchOrganizationDetail(),
      this.fetchActivityData(),
      this.fetchProductWarranteeData(),
      this.fetchRewardData(),
      this.fetchActionLogData(),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0],
        activityHistoryData: resArr[1],
        productWarranteeData: resArr[2],
        rewardHistoryData: resArr[3],
        actionLogData: resArr[4] || [],
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  fetchOrganizationDetail = async () => {
    let res = await portalService.GET_ORGANIZATION_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };
  fetchProductWarranteeData = async () => {
    let res = await portalService.GET_PRODUCT_WARRANTEE_BY_CUSTOMER_LIST(
      this.props.router.params.id,
      `?pagination=false`
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };
  fetchActivityData = async () => {
    let res = await portalService.GET_ACTIVITY_BY_CUSTOMER_LIST(
      this.props.router.params.id,
      `?pagination=false`
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };
  fetchRewardData = async () => {
    let res = await portalService.GET_REWARD_HISTORY_BY_CUSTOMER_LIST(
      this.props.router.params.id,
      `?pagination=false`
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };

  fetchActionLogData = async () => {
    let res = await portalService.GET_ORGANIZATION_ACTION_LOG(
      `?organization_ref_id=${this.props.router.params.id}&pagination=false&sort=created_at`
    );
    if (res && res.status === 200) {
      return res.data.docs;
    }
  };

  handleClickBack = (e) => {
    this.props.router.navigate(-1);
  };

  handleClickProductWarrantyDetail = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.PRODUCT_WARRANTY}/${e._id}`);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      isBgLoading,
      data,
      activityHistoryData,
      productWarranteeData,
      actionLogData,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === 'corperate');
    return (
      <CorperateDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section">
              <CorperateInfoWidget
                title="รายละเอียดองค์กร"
                data={data}
                permission={permission}
                timeline={
                  <Displays.ActionTimeline
                    items={RENDER_ORGANIZATION_TIMELINE(data, actionLogData)}
                  />
                }
                onBack={this.handleClickBack}
                onUpdateSuccess={this.fetchData}
                onDeleteSuccess={() =>
                  this.props.router.navigate(ROUTE_PATH.CORPERATE_LIST)
                }
              />
            </div>
            <div className="block_section">
              <div className="title">การลงทะเบียนประกันสินค้า</div>
              <div className="body">
                <Tables.Standard
                  columns={productWaranteeColumns({
                    handleClickProductWarrantyDetail:
                      this.handleClickProductWarrantyDetail,
                  })}
                  data={productWarranteeData.docs}
                />
              </div>
            </div>
            <div className="block_section">
              <div className="title">การลงทะเบียนกิจกรรม</div>
              <div className="body">
                <Tables.Standard
                  columns={activityHistoryColumns()}
                  data={activityHistoryData.docs}
                />
              </div>
            </div>
          </>
        )}
      </CorperateDetailContainerStyled>
    );
  }
}

const productWaranteeColumns = ({ handleClickProductWarrantyDetail }) => [
  {
    Header: <div style={{ textAlign: 'left' }}>Create Date</div>,
    accessor: 'created_at',
    Cell: (props) => (
      <div onClick={() => handleClickProductWarrantyDetail(props.row.original)}>
        {momentTZ(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Sn</div>,
    accessor: 'serial_no',
    Cell: (props) => (
      <div onClick={() => handleClickProductWarrantyDetail(props.row.original)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Item no</div>,
    accessor: 'item_no',
    Cell: (props) => (
      <div onClick={() => handleClickProductWarrantyDetail(props.row.original)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Dealer Code</div>,
    accessor: 'dealer_code',
    Cell: (props) => (
      <div onClick={() => handleClickProductWarrantyDetail(props.row.original)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Dealer Name</div>,
    accessor: 'dealer_name',
    Cell: (props) => (
      <div onClick={() => handleClickProductWarrantyDetail(props.row.original)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'center' }}>Status</div>,
    accessor: 'status',
    Cell: (props) => {
      const renderStatus = RENDER_STATUS_PRODUCT_WARRANTY(props.value);
      return (
        <div
          style={{ display: 'flex', justifyContent: 'center' }}
          onClick={() => handleClickProductWarrantyDetail(props.row.original)}
        >
          <Displays.StatusLabel
            bg={renderStatus?.bg}
            label={renderStatus?.label}
          />
        </div>
      );
    },
  },
];

const activityHistoryColumns = () => [
  {
    Header: <div style={{ textAlign: 'left' }}>Create Date</div>,
    accessor: 'created_at',
    Cell: (props) => (
      <div>
        {momentTZ(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Code</div>,
    accessor: 'activity_code',
    Cell: (props) => <div>{props.value}</div>,
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Name</div>,
    accessor: 'activity_name',
    Cell: (props) => <div>{props.value}</div>,
  },
  {
    Header: <div style={{ textAlign: 'left' }}>ชนิด</div>,
    accessor: 'activity_type',
    Cell: (props) => <div>{ACTIVITY_RENDER_TYPE(props.value)}</div>,
  },
  {
    Header: <div style={{ textAlign: 'left' }}>คะแนน</div>,
    accessor: 'activity_point',
    Cell: (props) => <div>{RenderCommaMoney(props.value, true)}</div>,
  },
  {
    Header: <div style={{ textAlign: 'center' }}>Status</div>,
    accessor: 'status',
    Cell: (props) => {
      const renderStatus = ACTIVITY_RENDER_STATUS(props.value);
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Displays.StatusLabel
            bg={renderStatus?.bg}
            label={renderStatus?.label}
          />
        </div>
      );
    },
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CorperateDetailContainer));
